import React, { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import { BiSearch, BiShow, BiTrash } from "react-icons/bi";
import Inputbox from "../Component/Inputbox";
import Button from "../Component/Button";
import axios from "axios";
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";
import Swal from "sweetalert2";
const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [newTitle, setNewTitle] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [errors, setErrors] = useState({
    newTitle: "",
    newMessage,
  });

  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${REACT_APP_API_URL}get-notification`);
      setNotifications(res.data.data || []);
    } catch (err) {
      console.error("Error fetching notifications:", err);
      showToast("error", "Failed to fetch notifications");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleSave = async () => {
    try {
      let newErrors = {
        newTitle: "",
        newMessage: "",
      };

      let hasError = false;

      if (newTitle.trim() === "") {
        newErrors.newTitle = "Please enter title";
        hasError = true;
      }

      if (newMessage.trim() === "") {
        newErrors.newMessage = "Please enter message";
        hasError = true;
      }

      setErrors(newErrors);
      if (hasError) return;

      setIsSaving(true);
      const response = await axios.post(
        `${REACT_APP_API_URL}add-notifications`,
        {
          title: newTitle,
          message: newMessage,
        }
      );

      if (response.data.success) {
        showToast("success", "Notification added successfully");
        setNewTitle("");
        setNewMessage("");
        await fetchNotifications();
        document.getElementById("addCloseBtn").click();
      } else {
        showToast(
          "error",
          response.data.message || "Failed to add notification"
        );
      }
    } catch (err) {
      console.error("Error adding notification:", err);
      showToast(
        "error",
        err.response?.data?.message || "Error adding notification"
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const response = await axios.get(
        `${REACT_APP_API_URL}delete-Notification/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );

      if (response.data.success) {
        showToast("error", "Notification deleted successfully");
        await fetchNotifications(); // refresh the notifications list
      } else {
        showToast(
          response.data.message || "Failed to delete notification",
          "error"
        );
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
      showToast(
        error.response?.data?.message || "Error deleting notification",
        "error"
      );
    }
  };

  const filteredNotifications = notifications.filter(
    (notification) =>
      notification.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      notification.message.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
      <div className="card">
        <div className="d-flex align-items-center justify-content-between px-5 py-3">
          <div className="nav-item d-flex align-items-center border rounded-2 ps-2">
            <BiSearch className="bx-md" />
            <input
              type="text"
              className="form-control border-0 shadow-none ps-1 ps-sm-2"
              placeholder="Search..."
              aria-label="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <button
            className="btn btn-outline-primary"
            data-bs-toggle="modal"
            data-bs-target="#addNotification"
          >
            Add Notification
          </button>
        </div>

        <div className="table-responsive text-nowrap">
          <table className="table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Title</th>
                <th>Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="table-border-bottom-0">
              {isLoading ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : filteredNotifications.length > 0 ? (
                filteredNotifications.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <p className="para m-0">{item.message}</p>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          className="btn btn-icon badge bg-label-success"
                          data-bs-toggle="modal"
                          data-bs-target="#viewNotification"
                          onClick={() => {
                            setTitle(item.title);
                            setDescription(item.message);
                          }}
                        >
                          <BiShow className="icon-md bx" />
                        </button>
                        <button
                          className="btn btn-icon delete-record badge bg-label-danger"
                          onClick={() => handleDelete(item.id)}
                        >
                          <BiTrash className="icon-md bx" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    {searchTerm
                      ? "No matching notifications found"
                      : "No notifications available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Notification Modal */}
      <div
        className="modal fade"
        id="addNotification"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Notification</h5>
              <button
                id="addCloseBtn"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={isSaving}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Title</label>
                <Inputbox
                  type="text"
                  placeholder="Enter title"
                  className="form-control"
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                  disabled={isSaving}
                />
                {errors.newTitle && (
                  <small className="text-danger">{errors.newTitle}</small>
                )}
              </div>
              <div>
                <label className="form-label">Message</label>
                <textarea
                  rows="4"
                  className="form-control"
                  placeholder="Enter message"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  disabled={isSaving}
                ></textarea>
                {errors.newMessage && (
                  <small className="text-danger">{errors.newMessage}</small>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-label-secondary border-0 ms-0 me-2"
                data-bs-dismiss="modal"
                disabled={isSaving}
              >
                Close
              </button>
              <Button
                className="m-0"
                type="button"
                onClick={handleSave}
                disabled={isSaving || !newTitle || !newMessage}
              >
                {isSaving ? "Saving..." : "Save changes"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* View Notification Modal */}
      <div
        className="modal fade"
        id="viewNotification"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="m-0">{description}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Notification;
